var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/_html.js
// module id = 1563
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 17 18 19 20 21